import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate({
		moreSelector: "span.endless_more",
		moreSelectorDataUrl: "data-more",
	});

	// Comment count
	for (const article of document.querySelectorAll("._comments_number")) {
		if (article.dataset.ct && article.dataset.id) {
			fetch(
				`/misc/comments_counter/${article.dataset.ct}/${article.dataset.id}/`,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					cache: "no-cache",
				},
			)
				.then((response) => response.json())
				.then((data) => {
					if (Number.parseInt(data.comment_count) > 149) {
						article.textContent = "HOT";
						article.classList.add("hot");
					} else {
						article.textContent = data.comment_count;
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		}
	}

	// Platform filter
	const newsContainer = document.querySelector("#_news_container");
	const filterButton = document.querySelector("#_filter_button");
	for (const el of document.querySelectorAll("a._nav_filter")) {
		el.addEventListener("click", (event) => {
			// filtro attivo
			if (filterButton) {
				if (el.innerText === "Tutte") {
					filterButton.innerText = "Piattaforme";
				} else {
					filterButton.innerText = el.innerText;
				}
			} else {
				for (const el of document.querySelectorAll("a._nav_filter")) {
					el.classList.remove("active");
				}
				el.classList.add("active");
			}

			// rimozione news presenti in pagina
			for (const div of newsContainer.querySelectorAll("div")) {
				div.remove();
			}
			newsContainer.insertAdjacentHTML(
				"beforeend",
				`<div class="text-center py-4" id="_loading_spinner">
            <div class="spinner-border text-primary" role="status"></div>
          </div>`,
			);
			const loadingSpinner = newsContainer.querySelector("#_loading_spinner");

			// retrieve data
			const url = "qs" in el.dataset ? el.dataset.qs : "?piattaforma=";
			fetch(url, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			})
				.then((response) => response.text())
				.then((data) => {
					loadingSpinner.remove();
					document
						.querySelector("#_news_container")
						.insertAdjacentHTML("beforeend", data);
				})
				.catch((error) => {
					console.warn(error);
				});
		});
	}
});
